<template>
  <v-app>
    <v-app-bar app color="indigo" dark class="no-print">
      <div class="d-flex align-center">
        <v-img alt="Inclusive Tech Group Logo" class="shrink mr-2" contain
          src="@/assets/itglogo.jpg" transition="scale-transition" width="40" />
        <span class="font-weight-bold">
          Inclusive Tech Group
        </span>
      </div>

      <v-spacer></v-spacer>

      <v-btn href="https://inclusivetechgroup.org" text>
        <v-icon>arrow_back</v-icon>
        <span class="mr-2">Back to Website</span>

      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
<style>
@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }
}
</style>
